export default __webpack_public_path__ + "static/media/laurentPic.3d6d01c6.png";